import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Icon,
  IconName,
  PayflipBadge
} from '../../atoms';
import { NavLinkButton } from './nav-link-button';

export type ExpandableMenuItemProps = {
  title: string;
  iconName: IconName;
  redBadge?: boolean;
  intercomTarget?: string;
  subLinks: Array<{
    selected: boolean;
    to: string;
    badge: boolean;
    title: string;
    isDisabled?: boolean;
    testId?: string;
    intercomTarget?: string;
  }>;
};

export function ExpandableMenuItem({
  title,
  redBadge = false,
  subLinks,
  iconName,
  intercomTarget,
  ...props
}: ExpandableMenuItemProps): JSX.Element {
  return (
    <AccordionItem border={0} data-intercom-target={intercomTarget ?? ''}>
      <AccordionButton
        {...props}
        role="button"
        _expanded={{ color: 'palette_gray.100' }}
        fontWeight={600}
        color="palette_gray.60"
      >
        <Icon w="1.1rem" h="1.1rem" mr="space_unit.x2" name={iconName} />
        <Flex
          w="100%"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
        >
          {title}
          {redBadge && <PayflipBadge />}
          <AccordionIcon />
        </Flex>
      </AccordionButton>
      <AccordionPanel mx="-space_unit.x2">
        {subLinks.map((subLink, i) => (
          <NavLinkButton
            data-testid={subLink.testId}
            isDisabled={subLink.isDisabled}
            key={`subLink.to${i}`}
            selected={subLink.selected}
            to={subLink.to}
            badge={subLink.badge}
            title={subLink.title}
            aria-label={subLink.title}
            px="space_unit.x4"
            data-intercom-target={subLink.intercomTarget ?? ''}
          >
            {subLink.title}
          </NavLinkButton>
        ))}
      </AccordionPanel>
    </AccordionItem>
  );
}
